import { Component, OnInit, Optional, Inject, PLATFORM_ID } from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Title, Meta } from '@angular/platform-browser';
import {Response} from 'express';

@Component({
  selector: 'not-found',
  templateUrl: './notFound.component.html',
  styleUrls: ['./notFound.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    //@Inject(PLATFORM_ID) private platformId: Object,
    //@Optional() @Inject(RESPONSE) private response: Response
  ) { }

  ngOnInit() {
    // if (!isPlatformBrowser(this.platformId)) {
    //   this.response.status(404);
    //   this.response.statusMessage = '404 - Page Not Found';
    // }

    // this.titleService.setTitle('Page introuvable');
    // this.metaTagService.updateTag({
    //     name: 'Page introuvable - erreur 404',
    //     content: 'Malheureusement, la page à laquelle vous tenter d\'accéder n\'existe pas.'
    // });

  }

}
